import * as React from 'react';
import styled from '@emotion/styled';

const IntroContent = styled('div')`
  flex-grow: 1;
  margin: 0;
  padding: 2rem 3rem;
  background: white;

  @media (max-width: 1024px) {
    padding: 1rem;

    img {
      max-width: 100%;
    }
  }
`;

class Intro extends React.PureComponent<{},{}> {
  render () {
    return (
      <IntroContent>
        <h1>Drills and Manual Introduction</h1>
        <p>
          The online version of the TRS Manual is available by clicking the relevant navigation link above.<br />
          <br />
          A printable version of the TRS Manual and Quickstart Guide can be <a target="_blank" href="/content/TRS Manual and Quickstart Guide.pdf">read or downloaded here</a>. This document requires a PDF viewer.<br />
          <br />
          A paper explaining the core concepts and personal development benefits of the TRS is available <a target="_blank" href="/content/TRS-Core-Concepts-&-Benefits-in-Personal-Development.pdf">from here</a>.  This document requires a PDF viewer.<br/>
          <br/>
          Drills are accessible by clicking the relevant navigation link above.<br />
          <br />
          Note that this section will be subject to upgrades from time to time.
        </p>
      </IntroContent>
    )
  }
};

export default Intro;
